var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('b-jumbotron',{attrs:{"header":_vm.page.name,"header-level":"4","header-tag":"h4"}}),_c('div',{domProps:{"innerHTML":_vm._s(_vm.page.html)}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }